import { AccountType } from '@/features/dashboard/paymentConfig/types/AccountType.ts';

export const accountTypeLabels: Record<AccountType, string> = {
  [AccountType.NRB]: 'Polskie konto',
  [AccountType.IBAN]: 'IBAN',
};

export const getAccountTypeLabel = (type: string): string => {
  return accountTypeLabels[type as AccountType] ?? type;
};

export const accountTypeOptions = Object.values(AccountType).map((value) => ({
  value,
  label: accountTypeLabels[value],
}));
